import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../Footer/Footer';
import Project from '../Project/Project';
import { db } from "../lib/init-firebase";
import loader from "../../images/Loading_icon.gif"
import { collection, getDocs } from "firebase/firestore";
import './Projects.css'

const categories = [
    {
        title: "All",
        categoryState: "All"
    },
    {
        title: "Web Design",
        categoryState: "web-design"
    },
    {
        title: "MERN Stack",
        categoryState: "mern-stack"
    },
    {
        title: "Mobile App",
        categoryState: "mobile-app"
    },
    {
        title: "DOM",
        categoryState: "dom"
    },
    {
        title: "Game",
        categoryState: "game"
    }
]

const Projects = () => {

    const [projects, setProjects] = useState([]);
    const [showingProjects, setShowingProjects] = useState([]);
    const [selectedOption, setSelectedOption] = useState("All")

    useEffect(() => {
        const projectsRef = collection(db, "projects");
        getDocs(projectsRef)
            .then((response) => {
                const newProjects = response.docs.map(doc => doc.data());
                newProjects.sort((a, b) => {
                    return a.serial - b.serial;
                });
                setProjects(newProjects);
                setShowingProjects(newProjects);
            })
            .catch((error) => console.log(error.message));
    }, []);

    if (projects.length === 0) {
        return (
            <>
                <Navbar />
                <div style={{ height: "100vh", backgroundColor: "#1A3D5D" }} className="d-flex justify-content-center align-items-center">
                    <img src={loader} width="100px" alt="" />
                </div>
            </>
        )
    }

    const changeCategory = (category) => {
        setSelectedOption(category)
        if (category == "All") {
            setShowingProjects(projects)
        }
        else {
            const newProjects = projects.filter(project => project.category === category)
            setShowingProjects(newProjects)
        }
    }

    return (
        <div style={{ backgroundColor: "#1a3d5d", color: 'white' }}>
            <Navbar />
            <div className="container">
                <h1 className="heading text-center pb-3 pt-5 mt-5"><span style={{ borderBottom: '5px solid #0bc2c2' }} className=""><span style={{ color: 'white' }}>My</span> <span style={{ color: '#0bc2c2' }}>Portfolio</span></span></h1>

                <div className="bar_bg">
                    <div className="row">
                        {
                            categories.map(category => (
                                <div className="col-md-2 col-sm-4 col-xs-3 d-flex justify-content-center ">
                                    <button
                                        onClick={() => changeCategory(category.categoryState)}
                                        className={`category-btn ${selectedOption == category.categoryState ? "selected" : "transparent"}`}
                                    >
                                        {category.title}
                                    </button>
                                </div>
                            ))
                        }
                    </div>

                </div>
                {
                    showingProjects.map(project => <Project key={project.serial} project={project} />)
                }
            </div>
            <Footer />
        </div>
    );
};

export default Projects;